// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ChangeUserTypeModal_modalContainer__1Lng0","modalContent":"ChangeUserTypeModal_modalContent__4vS55"};